import { AppBar, createStyles, IconButton, ListItem, ListItemText, makeStyles, Theme, Toolbar, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useRef, useState, useLayoutEffect, CSSProperties, useEffect, useMemo } from "react";
import { FixedSizeList as List } from "react-window";
import { Facility, FacilityGroup } from "../../db/stores/facilities";
import { useDataValue } from './form';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux';
import Search from './Search';

export interface FacilityGroupQueryParams {
  facility: Facility | null;
}
  

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
    toolbarButton: {
      marginRight: theme.spacing(2),
    },
    toolbarTitle: {
      marginRight: theme.spacing(4),
      flexShrink: 0,
    },
    search: {
      maxWidth: theme.breakpoints.width("sm"),
      width: "100%",
    },
    list: {
      height: "calc(100% + 96px)",
      WebkitOverflowScrolling: "touch",
    },
  })
);

interface FacilityGroupSelectProps {
  onSelect: (facilityGroup: FacilityGroup | null) => void;
}
const ITEM_SIZE = 52;

function facilityGroupSearchFilter(text: string) {
  const exp = new RegExp(text, "i");
  return function (facilityGroup: FacilityGroup) {
    return exp.test(facilityGroup.name as string);
  };
}

export default (props: FacilityGroupSelectProps) => {
  const classes = useStyles(props);
  const facilityId = useDataValue<string>('{/facility/id}');
  const facilities = useSelector((state: AppState) => state.facilities.items);
  const [facilityGroups, setFacilityGroups] = useState<FacilityGroup[]>([]);
  const [filter, setFilter] = useState<string>("");

  const filteredFacilityGroups = useMemo(() => {
    if (!facilityGroups) {
      return [];
    }
    return facilityGroups.filter(facilityGroupSearchFilter(filter));

  }, [facilityGroups, filter]);

  useEffect(() => {
    if (facilities && facilityId && facilities[facilityId]) {
      setFacilityGroups(facilities[facilityId].groups as FacilityGroup[]);
    }
  }, [facilities, facilityId])

  const rootRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (rootRef.current) {
      setHeight((rootRef.current as any).clientHeight);
    }
  }, [height])
  
  return (
    <div className={classes.root}>
      <AppBar position="sticky">
        <Toolbar color="primary" variant="dense">
          <IconButton
            className={classes.toolbarButton}
            edge="start"
            color="inherit"
            onClick={() => props.onSelect(null)}
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.toolbarTitle} variant="h6">
            Select Facility Group
          </Typography>
          <Search className={classes.search} onSearchUpdated={setFilter} showClear />
        </Toolbar>
      </AppBar>

      <div className={classes.list} ref={rootRef}>
        <List
          itemSize={ITEM_SIZE}
          itemCount={filteredFacilityGroups.length}
          height={height}
          width="100%"
        >
          {({ index, style }) => {
            console.log('ALL GROUPS FOR THIS FACILITY:', filteredFacilityGroups);
            const f = JSON.parse(JSON.stringify(filteredFacilityGroups[index]));  // copy since we are going to mutate

            return (
              <ListItem style={style as CSSProperties} key={f.name} button onClick={() => {
                props.onSelect(f);
              }}>
                <ListItemText primary={ f.name } secondary={''} />
              </ListItem>
            );
          }}
        </List>
      </div>
    </div>
  );
};
